// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-section-1{
    height: 526px;
    width: 100%;
    display: flex;
    background-size: cover; 
    background-position: center; 
    background-attachment: fixed;
    
}
.invalid-feedback {
  color: #dc3545 !important;
  font-size: 12px !important;
  line-height: 20px !important;
}

/* CLASS STYLES */
.contact-section-1 .banner-content {
  padding: 70px 0;
  width: 80%;
  margin: 0 auto;
  margin-top: 3rem;
}

.contact-section-1.img_container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100vw;
  height: 80vh;
}


.contact-section-1.img_container img {
  position: absolute;
  z-index: -1;
  opacity: 1;
  /* animation: fade-out linear forwards;
  animation-timeline: view();
  animation-range: exit; */
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  
}

/* 
@keyframes fade-out {
  50% { 
    transform: scale(1.2);
    opacity: 0;
   }
   100% { 
    transform: scale(1);
    opacity: 0;
   }
 
} */



.contact-section-1 h1 {
  font-size: 52px ;
  font-weight: 700;
  line-height: 58px;
  margin-bottom: 1rem;
}
.contact-section-1 h1 span{
  color: #FAEC24;
}

.contact-section-1 p {
  text-align: left;
  font-weight: 400;
  width: 75%;
}




.contact-section-2{
    padding-top: 6rem;
    padding-bottom: 6rem;
    background: #ffffff;

}

.contact-section-2 h1{
    color: #000;
    font-size: 38px;
}
.contact-section-2 .form-select {
    border: none !important;
    border-bottom: 1px solid #8A9CAE !important; 
    border-radius: 0;
}
.contact-section-2 .form-section input{
    border: none !important;
    border-bottom: 1px solid #8A9CAE !important; 
    color: #000 !important;
    border-radius: 0;
}
.contact-section-2 .form-section #email,.contact-section-2 .form-section #phone{
    border-radius: 0px;
}
#exampleFormControlTextarea1{
    margin-top: 3rem;
    /* border: none !important; */
    border: 1px solid #8A9CAE !important; 
    /* color: #000 !important; */
}
#firstName::placeholder, #lastName::placeholder{
    color: #000 !important;
}


.contact-section-1 p{
    width: 55%;
}

.submit-msg .alert-success{
  font-size: 16px;
  padding: 0.5rem 0.5rem;
    height: 2.6rem;
    margin-left: 2rem;
  line-height: 25px;
}
.fade-out-animation {
  animation: fadeOut 3s forwards;
}
@keyframes fadeOut {
  0% { opacity: 1; }
  100% { opacity: 0; }
}

@media (max-width:576px) {
  .contact-section-1 p{
    width: 100%;
    font-size: 15px;
    line-height: 24px;
  }
  
  .contact-section-1 h1{
    font-size: 38px;
    line-height: 44px;
  }
  .contact-section-1 .banner-content {
    margin-top: 7rem;
  }
  .contact-section-1.img_container{
    height: 100vh;
  }
  .contact-section-1.img_container img {
    animation-duration: 2s; 
  }
  .contact-section-2 .form-select{
    margin-bottom: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Contact.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;;AAEhC;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV;;0BAEwB;EACxB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;;AAEzB;;AAEA;;;;;;;;;;;GAWG;;;;AAIH;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;;;;AAKA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B;AAChC;AACA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,UAAU;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;IACpB,cAAc;IACd,iBAAiB;EACnB,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".contact-section-1{\r\n    height: 526px;\r\n    width: 100%;\r\n    display: flex;\r\n    background-size: cover; \r\n    background-position: center; \r\n    background-attachment: fixed;\r\n    \r\n}\r\n.invalid-feedback {\r\n  color: #dc3545 !important;\r\n  font-size: 12px !important;\r\n  line-height: 20px !important;\r\n}\r\n\r\n/* CLASS STYLES */\r\n.contact-section-1 .banner-content {\r\n  padding: 70px 0;\r\n  width: 80%;\r\n  margin: 0 auto;\r\n  margin-top: 3rem;\r\n}\r\n\r\n.contact-section-1.img_container {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  max-width: 100vw;\r\n  height: 80vh;\r\n}\r\n\r\n\r\n.contact-section-1.img_container img {\r\n  position: absolute;\r\n  z-index: -1;\r\n  opacity: 1;\r\n  /* animation: fade-out linear forwards;\r\n  animation-timeline: view();\r\n  animation-range: exit; */\r\n  top: 0px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n  \r\n}\r\n\r\n/* \r\n@keyframes fade-out {\r\n  50% { \r\n    transform: scale(1.2);\r\n    opacity: 0;\r\n   }\r\n   100% { \r\n    transform: scale(1);\r\n    opacity: 0;\r\n   }\r\n \r\n} */\r\n\r\n\r\n\r\n.contact-section-1 h1 {\r\n  font-size: 52px ;\r\n  font-weight: 700;\r\n  line-height: 58px;\r\n  margin-bottom: 1rem;\r\n}\r\n.contact-section-1 h1 span{\r\n  color: #FAEC24;\r\n}\r\n\r\n.contact-section-1 p {\r\n  text-align: left;\r\n  font-weight: 400;\r\n  width: 75%;\r\n}\r\n\r\n\r\n\r\n\r\n.contact-section-2{\r\n    padding-top: 6rem;\r\n    padding-bottom: 6rem;\r\n    background: #ffffff;\r\n\r\n}\r\n\r\n.contact-section-2 h1{\r\n    color: #000;\r\n    font-size: 38px;\r\n}\r\n.contact-section-2 .form-select {\r\n    border: none !important;\r\n    border-bottom: 1px solid #8A9CAE !important; \r\n    border-radius: 0;\r\n}\r\n.contact-section-2 .form-section input{\r\n    border: none !important;\r\n    border-bottom: 1px solid #8A9CAE !important; \r\n    color: #000 !important;\r\n    border-radius: 0;\r\n}\r\n.contact-section-2 .form-section #email,.contact-section-2 .form-section #phone{\r\n    border-radius: 0px;\r\n}\r\n#exampleFormControlTextarea1{\r\n    margin-top: 3rem;\r\n    /* border: none !important; */\r\n    border: 1px solid #8A9CAE !important; \r\n    /* color: #000 !important; */\r\n}\r\n#firstName::placeholder, #lastName::placeholder{\r\n    color: #000 !important;\r\n}\r\n\r\n\r\n.contact-section-1 p{\r\n    width: 55%;\r\n}\r\n\r\n.submit-msg .alert-success{\r\n  font-size: 16px;\r\n  padding: 0.5rem 0.5rem;\r\n    height: 2.6rem;\r\n    margin-left: 2rem;\r\n  line-height: 25px;\r\n}\r\n.fade-out-animation {\r\n  animation: fadeOut 3s forwards;\r\n}\r\n@keyframes fadeOut {\r\n  0% { opacity: 1; }\r\n  100% { opacity: 0; }\r\n}\r\n\r\n@media (max-width:576px) {\r\n  .contact-section-1 p{\r\n    width: 100%;\r\n    font-size: 15px;\r\n    line-height: 24px;\r\n  }\r\n  \r\n  .contact-section-1 h1{\r\n    font-size: 38px;\r\n    line-height: 44px;\r\n  }\r\n  .contact-section-1 .banner-content {\r\n    margin-top: 7rem;\r\n  }\r\n  .contact-section-1.img_container{\r\n    height: 100vh;\r\n  }\r\n  .contact-section-1.img_container img {\r\n    animation-duration: 2s; \r\n  }\r\n  .contact-section-2 .form-select{\r\n    margin-bottom: 0 !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
